import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';
import Pipe from './../Pipe/Pipe.jsx';
import { ReactComponent as Hoop } from '../../icons/svg/hoop.svg';

export default class RegularContentBox extends NrgComponent {

  render() {
    return (
      <div className="RegularContentBox row">
        <div className="col-xs-16">
          <Pipe scrollProgressType="pipe" />
          <div className="row statement line1">
            <div className="col-xs-16" data-scroll-item-once="hoop">
              <h3 data-scroll-item-once>{Content[this.props.page].line1}</h3>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
            </div>
          </div>
          <Pipe scrollProgressType="pipe" />
          <div className="row statement line2" data-scroll-item-once="opacity">
            <div className="col-xs-16 hoops" data-scroll-item-once="hoop">
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
            </div>
            <div className="col-xs-16">
              <h3 data-scroll-item-once>{Content[this.props.page].line2}</h3>
            </div>
          </div>
          <Pipe scrollProgressType="pipe" />
          <div className="row statement line3" data-scroll-item-once="opacity">
            <div className="col-xs-16" data-scroll-item-once="hoop">
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <h3 data-scroll-item-once>{Content[this.props.page].line3}</h3>
            </div>
          </div>
          <Pipe scrollProgressType="pipe" />
          <div className="row statement">
            <div className="col-xs-16">
              <h3 data-scroll-item-once>{Content[this.props.page].line4}</h3>
            </div>
          </div>
          <Pipe additionalClassName="one" scrollProgressType="pipe" />
          <div className="row statement line5 last" data-scroll-item-once="opacity">
            <div className="col-xs-16" data-scroll-item-once="hoop">
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <div className="hoop-wrap">
                <Hoop viewBox="0 0 185 185"></Hoop>
              </div>
              <h3 data-scroll-item-once>{Content[this.props.page].line5}</h3>
            </div>
          </div>
          <Pipe scrollProgressType="pipe" />
        </div>
      </div>
    );
  }

};
